import React, { useState } from 'react'
import PercentageRangeSlider from 'components/PercentageRangeSlider'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { Form as AntdForm } from 'antd'
import Select from 'components/Select'

export const StyledHeading = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 15px;
  color: ${props => (props.color ? props.color : COLORS.BLACK)};
`
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 0px !important;
  margin-right: 14px !important;
`

const SalaryFilter = ({ setSalaryChange }) => {
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(100)
  const onMinValueChange = val => {
    setMinValue(val)
    setSalaryChange({ minValue: val * 100000, maxValue: maxValue * 100000 })
  }
  const onMaxValueChange = val => {
    setMaxValue(val)
    setSalaryChange({ minValue: minValue * 100000, maxValue: val * 100000 })
  }
  const currencyOptions = [
    {
      id: '1',
      name: 'All Currency',
      value: 'All',
    },
  ]
  return (
    <>
      <StyledHeading>Salary</StyledHeading>
      <StyledHeading color={COLORS.BLACK_WHITE_B_50}>
        {minValue}LPA - {maxValue}LPA
      </StyledHeading>

      <PercentageRangeSlider
        minValue={minValue}
        setMinValue={onMinValueChange}
        maxValue={maxValue}
        setMaxValue={onMaxValueChange}
      />
      <div>
        <FormItem
          name="currency"
          rules={[{ required: true, message: 'Please enter degree name!' }]}
        >
          <Select
            label="Select Currency *"
            valueParam={'value'}
            placeholder="Eg. Bachlore of Engineering - B.E"
            OptionData={currencyOptions}
            optionLabelProp="name"
            defaultValue="All Currency"
          />
        </FormItem>
      </div>
    </>
  )
}

export default SalaryFilter
